import { fbDB } from "../config/firebase";
import { QUIZ1_DATA_WATCH, QUIZ1_DATA_UPDATE, QUIZ1_META_WATCH } from "./types";

export const quiz1DataWatch = () => async dispatch => {
  fbDB.ref(`/activities/quizzes/data/quiz1`).on("value", snapshot => {
    return dispatch({
      type: QUIZ1_DATA_WATCH,
      payload: {
        data: snapshot.val()
      }
    });
  });
};

export const quiz1DataUpdate = (idx, data) => async dispatch => {
  fbDB
    .ref(`/activities/quizzes/data/quiz1/${idx}`)
    .update({
      ...data
    })
    .then(() => {
      return dispatch({
        type: QUIZ1_DATA_UPDATE,
        payload: null
      });
    })
    .catch(err => {
      console.log(err);
    });
};

export const quiz1MetaWatch = () => async dispatch => {
  fbDB.ref(`/activities/quizzes/meta/quiz1`).on("value", snapshot => {
    return dispatch({
      type: QUIZ1_META_WATCH,
      payload: {
        meta: snapshot.val()
      }
    });
  });
};
